import { BucketingStrategy } from './bucketing-strategy';
import { BaseBucketingStrategy } from './base-bucketing-strategy';
import { BucketDef } from './bucket-def';
import * as moment from 'moment';

export class DailyBucketing extends BaseBucketingStrategy implements BucketingStrategy {

    constructor(todayStr: string, expandFirstBucket?: boolean) {
        super(todayStr, expandFirstBucket);
    }

    initBucketDefs() {
        this.bucketDefs.push(new BucketDef(this.today.clone().add(30, 'days'), this.today, true, '30D'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 2, true), this.startOfNextBucket(), true, '2M'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 3, true), this.startOfNextBucket(), true, '3M'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 4, true), this.startOfNextBucket(), true, '4M'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 5, true), this.startOfNextBucket(), true, '5M'));
        this.bucketDefs.push(new BucketDef(this.addMonths(this.today, 6, true), this.startOfNextBucket(), true, '6M'));
    }

    strategyName(): string {
        return 'Daily';
    }
}
